import React from "react";

const Services = () => (
  <section className="services" id="services">
    <div className="service-card">
      <div className="service-icon">📞</div>
      <h3>Call us +91 89566 19631</h3>
      <p>We remain available 24/7 for assistance.</p>
    </div>
    <div className="service-arrow">→</div>
    <div className="service-card">
      <div className="service-icon">👨‍🔧</div>
      <h3>Expert evaluation</h3>
      <p>Our experts will evaluate the Requirement.</p>
    </div>
    <div className="service-arrow">→</div>
    <div className="service-card">
      <div className="service-icon">🚚</div>
      <h3>We will reach out</h3>
      <p>Our team will reach out to you for the further process.</p>
    </div>
  </section>
);

export default Services; 